import React from "react";
import "./About.css";
import MainMenu from "../components/navigations/MainMenu";

const Affiliation = () => {
  return (
    <div className="relative about">
      <div className="absolute top-0 left-0">
        <MainMenu bg="gray-900" />
      </div>
      <div
        className="pt-20 about__container flex justify-center items-center"
        style={{
          backgroundImage: `linear-gradient(
          rgb(200, 200, 200, 0.7),
          rgb(0, 0, 0, 0.9)
  ), url("/images/about.JPG")`,
          height: "75vh",
          width: "100%",
          backgroundSize: "cover",
          backgroundPosition: "center center",
        }}
      >
        <div className="">
          <h1 className="text-white text-center font-bold text-5xl md:text-6xl font-serif uppercase">
            Affiliation
          </h1>
        </div>
      </div>
      <div className="p-6 mb-10 font-serif max-w-3xl mx-auto">
        <p>
          St. John High School- Raio, is recognized by the Govt. of Tripura. It
          is affiliated to CBSE (Central Board of Secondary Education) New
          Delhi. The Affiliation number is . 2030028
        </p>
      </div>
    </div>
  );
};

export default Affiliation;
